<template>
  <div class="form_box">
    <div class="form_box__header">
      <AppPageHeader></AppPageHeader>
    </div>
    <el-card class="box-card">
      <div class="form_box__group__item">
        <div class="form_box__group__item__title">学习班名称：</div>
        <div class="form_box__group__item__content">{{details.title}}</div>
      </div>
      <div class="form_box__group__item">
        <div class="form_box__group__item__title">学习班创建时间：</div>
        <div class="form_box__group__item__content">{{details.cdate}}</div>
      </div>
      <div class="form_box__group__item">
        <div class="form_box__group__item__title">开班单位/党组织：</div>
        <div class="form_box__group__item__content">{{details.createUnit}}</div>
      </div>
      <div class="form_box__group__item">
        <div class="form_box__group__item__title">排课数：</div>
        <div class="form_box__group__item__content">{{details.snums}}</div>
      </div>
      <!-- <div class="form_box__group__item">
        <div class="form_box__group__item__title">累计学时：</div>
        <div class="form_box__group__item__content">{{details}}</div>
      </div> -->
      <div class="form_box__group__item">
        <div class="form_box__group__item__title"></div>
        <div class="form_box__group__item__content">
          <ExportStudyClassBtn 
            ref="ExportStudyClassBtn"
            :serverUrl = "EXPORT_URL_STUDYCLASS"
            :filename="EXPORT_FN_STUDYCLASS"
          ></ExportStudyClassBtn>
        </div>
      </div>
    </el-card>

    <el-card class="box-card">
      <el-table :data="schedulings" style="width: 100%">
        <el-table-column label="排课信息" prop="information"></el-table-column>
        <el-table-column label="排课地址" prop="address"></el-table-column>
         <el-table-column label="排课状态">
          <template slot-scope="scope">
           {{ scope.row.schedulingStatus? '已结束':'未结束' }}
          </template>
         </el-table-column>
        <el-table-column label="完成人数" prop="checkedUsers"></el-table-column>
        <el-table-column align="left">
          <template slot="header">查看详情</template>
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="goClassPlanDetail(scope.row.sid)">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import { ExportStudyClassBtn } from "@/views/module/export/comp";
import {studyclassHoursDetailApi} from '@/api/module/studyclass/studyclass'

export default {
  name: "studyclass-hours-detail",

  components: {
    ExportStudyClassBtn
  },
  data() {
    return {
      details: {},       
      schedulings : [],    
      EXPORT_URL_STUDYCLASS : "/api/manager/export/studyclass",
      EXPORT_FN_STUDYCLASS : "学习班数据.xls"
    }
  },
  methods:{
    goClassPlanDetail(e){
      this.$router.push({
        path:'/export/classPlanDetail',
        query:{
          id:e
        }
      })
    },
    getstudyclassHoursDetail(){
      let data = {
        id:this.sid
      }
      studyclassHoursDetailApi(data).then((res)=>{
        console.log("data",res)
        if(res){
          this.schedulings = res.schedulingDetails
          this.details = res.detailMVO
        }
        // this.info = res[0];
        // this.infoArr = res[1]
      })
    }

  },
  mounted(){
    this.$refs.ExportStudyClassBtn.updateParams("sid",this.sid);
  },
  created() {
    this.sid = this.$route.query.id;
    this.getstudyclassHoursDetail()
  }
}




</script>





<style scoped lang='scss'>
.box-card {
  margin-bottom: 20px;
  .userName {
    padding-left: 10px;
    margin-bottom: 10px;
    .title {
      color: #303133;
      font-size: 14px;
      font-weight: 500;
      display: inline-block;
      width: 70px;
    }
    .cont {
      font-size: 14px;
      color: #3e3e3e;
    }
  }
}
.clearfix {
  font-size: 16px;
  color: #303133;
  font-weight: 600;
}
.el-pagination {
  text-align: center;
  margin-top: 30px;
}
.form_box__group__item__title{
  width: 130px;
}
</style>